import {HTMLAttributes, ReactNode} from "react";
import {cn} from "@/lib/utils";

interface IProps extends HTMLAttributes<HTMLDivElement>{
    title: string;
    icon: ReactNode;
}

export default function PageTitle({title, icon, className, ...props}: IProps) {
    return (
        <div className={cn('flex items-center gap-[8px] py-[3px] text-white', className)} {...props}>
            <div>{icon}</div>
            <span className={'font-bold text-[20px] leading-none block'}>{title}</span>
        </div>
    )
}
